<span class="ui-tooltip" [ngClass]="'size-' + size" appPopper [target]="tooltip" arrowClass="ui-tooltip-arrow">
  <ng-container *ngIf="icon?.length; else defaultIcon">
    <img [src]="icon" />
  </ng-container>
  <ng-template #defaultIcon>
    <div class="icon-i-info" [ngClass]="'icon-color-' + color"></div>
  </ng-template>
  <span class="ui-tooltip-content" #tooltip>
    <span class="ui-tooltip-arrow"></span>
    <span *ngIf="title" class="title" [innerHTML]="title"></span>
    <span *ngIf="content" [innerHTML]="content"></span>
    <ng-content></ng-content>
  </span>
</span>
